
export const services = [
    {
        title: "Coding",
        icon: 'https://csgeeek.github.io/web.png',
    },
    {
        title: "Music",
        icon: 'https://csgeeek.github.io/web.png',
    },
    {
        title: "Sports",
        icon: 'https://csgeeek.github.io/web.png',
    },
    {
        title: "Travel",
        icon: 'https://csgeeek.github.io/web.png',
    },
    {
        title: "Technical Reporting & Reading",
        icon: 'https://csgeeek.github.io/web.png',
    },
];

export const name = 'Sumer';

export const experiences = [
    {
        'company': 'PanAfrican Equipment Group',
        'role': 'Full Stack Developer',
        'duration': 'Present',
        'logo': '/panafrican.png',
        'points': [
            // 'Gained experience with Git version control contributing to the development and maintenance of code repositories.',
            // 'Worked on the application dashboard, making it more user-friendly and improving its overall functionality📱.'
        ],
        'url': 'https://www.att.com/',
    },
    {
        'company': 'Sharaf DG',
        'role': 'Software Developer',
        'duration': 'August 2024 - March 2025',
        'logo': '/sharafdg.jpg',
        'points': [
            // 'Involved in dynamic contributions to web and mobile📱 development projects, actively influencing and improving project outcomes.',
            // 'Developed multiple shared components to simplify tasks for fellow developers, boosting efficiency and teamwork.',
            // 'Enhanced product performance through significant contributions to backend development, optimizing essential components for improved efficiency 📈.',
            // 'Implemented data security for the company’s product to provide role-based access control ⚙️.'
        ],
        'url': 'https://uae.sharafdg.com',
    },
    {
        'company': 'Sharaf DG',
        'role': 'Junior Software Developer',
        'duration': 'Aug 2023 - Aug 2024',
        'logo': '/sharafdg.jpg',
        'points': [
            // 'Gained experience with Git version control contributing to the development and maintenance of code repositories.',
            // 'Worked on the application dashboard, making it more user-friendly and improving its overall functionality📱.'
        ],
        'url': 'https://uae.sharafdg.com',
    },
    {
        'company': 'Sharaf DG',
        'role': 'Software Developer Intern',
        'duration': 'Jan 2023 - Aug 2023',
        'logo': '/sharafdg.jpg',
        'points': [
            // 'Gained experience with Git version control contributing to the development and maintenance of code repositories.',
            // 'Worked on the application dashboard, making it more user-friendly and improving its overall functionality📱.'
        ],
        'url': 'https://www.att.com/',
    },

]



export const EMAIL_JS_SERVICE_ID = 'service_y226nsx';
export const EMAIL_JS_TEMPLATE_ID = 'template_ngs1ubn';
export const EMAIL_JS_PUBLIC_KEY = 'K3D_5ekrZCMsI4lyD';